import {useState,useContext} from 'react'
import { useNavigate } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import { LanguageContext } from '../../context';
import './SearchHeader.css'
import Translate from '../Translate/Translate';

const SearchHeader = () => {

  const [searchText,setSearchText]=useState();
  const [isClose,setIsClose]=useState('close');
  const { language } = useContext(LanguageContext);
  const navigate = useNavigate();

  const handleClickSearch=(e)=>{
    setIsClose(isClose=='txt-search'?'close txt-search':'txt-search');
  }

  const handleKeyPressSearch=(e)=>{
    if(e.key=="Enter")
      setIsClose(isClose=='txt-search'?'close txt-search':'txt-search');
  }

  const handleChange=(e)=>{
    setSearchText(e.target.value);
  }

  const checkEnter=(e)=>{
    if(e.key=="Enter")
      searchHandle()
  }

  const searchHandle=(e)=>{
    navigate(`/?k=${searchText}`)
  }

  return (
    <div className='search-header-container' >
        <a className="search-icon"  href="#" title="חיפוש" >
            
            <div className="search-button" onClick={handleClickSearch} onKeyPress={handleKeyPressSearch} ></div>
        </a>
       <div className={isClose}>
         <TextField id="standard-basic" label={<Translate>SearchHeaderLable</Translate>} variant="standard" onChange={handleChange} onKeyDown={checkEnter} />
       </div>
    </div>
  )
}

export default SearchHeader